/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect} from 'react'
import {Column} from 'react-table'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCell,
} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {TabModel} from '../../../../../../models'
import {BathRoomModel} from '../../models'
import {getBathRoomsService} from '../../services/getBathRooms.service'

const TableBathRooms: FC = () => {
  const {data, setData, setPagination, loading, setLoading, pagination} = useKTable()
  const {changeCurrentTabItem, currentTabItem} = useHoteleria()

  const getBathRooms = async () => {
    try {
      setLoading(true)
      const {data: response} = await getBathRoomsService({
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
      })
      if (!response.error) {
        setData(response.data)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const handleEditItem = (item: BathRoomModel) => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: true,
      content: {
        ...currentTabItem.content,
        detailPanel: 'form-edit-bathroom',
      },
      idToEdit: item.Id,
    }
    changeCurrentTabItem(obj)
  }
  useEffect(() => {
    getBathRooms()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination])

  const columns: Column<BathRoomModel>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} />,
      id: 'selection',
      Cell: ({...props}) => <KTableSelectionCell id={props.data[props.row.index].Id} />,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Id' />,
      accessor: 'Id',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) => (
        <div
          className='d-flex justify-content-center flex-shrink-0'
          onClick={() => handleEditItem(props.row.original)}
        >
          <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
            <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
          </a>
        </div>
      ),
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Modulo' />,
      accessor: 'ModuloId',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Baño' />,
      accessor: 'TipoBanioId',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Sexo' />,
      accessor: 'SexoId',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Codigo' />,
      accessor: 'Codigo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Habitacion' />,
      accessor: 'HabitacionId',
    },

    {
      Header: (props) => <KTableHeader tableProps={props} title='FecRegistro' />,
      accessor: 'FecRegistro',
    },
  ]

  useEffect(() => {
    setInitialPagination()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setInitialPagination = async () => {
    try {
      const {data: response} = await getBathRoomsService({
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
      })
      setPagination({
        perPage: 10,
        currentPage: 1,
        totalResults: response.total,
      })
    } catch (error) {}
  }

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='d-flex justify-content-end p-2 me-5'>
          {/* <button
            className='btn btn-primary me-3'
            disabled={selected.length < 1}
            onClick={handleDelete}
          >
            Eliminar
          </button> */}
        </div>
        <KTable data={data} columns={columns} />
        {loading ? <KTableLoading title='Cargando...' /> : null}
      </KTCard>
    </>
  )
}

const TableBathRoomsWrapper = () => {
  return (
    <KTableProvider>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Listado de Baños</Tab>
          </TabList>
          <TabPanel>
            <TableBathRooms />
          </TabPanel>
        </Tabs>
      </div>
    </KTableProvider>
  )
}

export {TableBathRoomsWrapper}
